import { ContactInfoWidgetProps } from "../../js/headersegment/interfaces";
import { travelerProfileDetails, tripHasContacts } from "../../js/lib/trip";
import React from "react";

const ContactInfoWidget: React.FC<ContactInfoWidgetProps> = ({ contactsMap, canManageIssues, awayContactPointAvailable }) => {

    return (<>
      <div className="widget">
        <div className="header">CONTACT INFORMATION</div>
        <div className="data">
          <table className="table table-condensed">
            {tripHasContacts(contactsMap) ? (
              <tbody>
                {Object.entries(contactsMap).map(([travelerKey, travelerProfile]) => (
                  <tr key={travelerKey}>
                    <td className="table-entry" data-fs-exclude>
                      {travelerProfile ? (
                        <a onClick={() => travelerProfileDetails(travelerKey)}>
                          {travelerKey}
                        </a>
                      ) : (
                        travelerKey
                      )}
                    </td>
                    {canManageIssues() && (
                      <td className="messageIcon table-entry">
                        {awayContactPointAvailable(travelerKey) && (
                          <div>
                            <a
                              title="Send Message"
                              href={`mailto:${travelerKey}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <div className="sprites sprite-message-selected-16"></div>
                            </a>
                          </div>
                        )}
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td className="none-found">No contact information.</td>
                </tr>
              </tbody>
            )}
          </table>
        </div>
      </div>
    </>);
}

export default ContactInfoWidget;